import Vue from "vue";
import { VueOfflineStorage } from "vue-offline";
import { authHTTP } from "@/services/axios.service";
import { handleError } from "@/functions/handleError.function";

// initial state
const state = {
  error: {},
  results: [],
  aircraft: [],
  pageSize: 0,
  branding: {
    icon: "",
    logo: "",
    iconsize: "5rem",
    logosize: "6rem"
  }
};

// getters
const getters = {
  error: state => {
    return state.error;
  },
  submit: state => {
    return state.submit;
  },
  aircraft: state => {
    return state.aircraft;
  },
  results: state => {
    return state.results;
  },
  pageSize: state => {
    return state.pageSize;
  },
  branding: state => {
    return state.branding;
  }
};

// actions (async)
const actions = {
  getResults(context) {
    authHTTP
      .get("results/")
      .then(function(response) {
        state.results = response.data;
        VueOfflineStorage.set("results", response.data);
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("setError", data);
      });
  },
  getAircraft(context) {
    authHTTP
      .get("aircraft/")
      .then(function(response) {
        state.aircraft = response.data;
        VueOfflineStorage.set("aircraft", response.data);
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("setError", data);
      });
  }
};

// mutations (sync)
const mutations = {
  setResults(state, value) {
    state.results = value;
  },
  setAircraft(state, value) {
    state.aircraft = value;
  },
  setError(state, payload) {
    for (const err in payload) {
      Vue.set(state.error, err, payload[err]);
    }
  },
  clearErrors() {
    state.error = {};
  },
  clearState() {
    state.results = [];
    state.aircraft = [];
  },
  setPageSize(state, value) {
    state.pageSize = value;
  },
  setBranding(state, payload) {
    for (const obj in payload) {
      Vue.set(state.branding, obj, payload[obj]);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
